export default class AddInvestmentProfileRequest {
    name: String;
    companyId: number;
    investmentProfileId: number;
    bankAccountId: number;
    amount: number;
    minInvoiceAmount: number;
    maxInvoiceAmount: number;
    comment: string;
    marketPlace: string;
  }
  